import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import { getStoreService } from '../../services/store';
import { setStoreData } from '../../modules/common';
import SignUpV2Flow from '../../pages/SignUpV2/SignUpV2Flow';

/**
 * Clean authenticated container for `/onboarding/*` (signup v2 steps 3–5):
 * no sidebar, no AppContainer modals, no WhatsApp widget, no plan banners.
 */
const OnboardingContainer = () => {
    const dispatch = useDispatch();
    const storeId = useSelector((state) => state.auth.storeId);

    useEffect(() => {
        if (!storeId) return undefined;
        let cancelled = false;
        getStoreService(storeId)
            .then(({ data }) => {
                if (!cancelled) dispatch(setStoreData(data));
            })
            .catch(() => {
                /* Expired sessions are handled by the axios interceptor. */
            });
        return () => {
            cancelled = true;
        };
    }, [storeId, dispatch]);

    return (
        <main>
            <Route path="/onboarding/:step?" render={() => <SignUpV2Flow mode="onboarding" />} />
        </main>
    );
};

export default OnboardingContainer;
